<template>
  <section class="contact">
    <h1>{{title}}</h1>
    <div class="row">
      <aside class="col-xs-12 col-lg-6">
        <contactform />
      </aside>
      <aside class="col-xs-12 col-lg-6">
        <div class="row end-lg">
          <div class="col-xs-12 col-sm-10">
            <div class="box">
              <div class="contact-info">
                <div class="title">BUSINESS ENQUIRY</div>
                <a href="mailto:interact@huehexdesign.com">interact@huehexdesign.com</a>
                +91-8792741516
              </div>
              <div class="contact-info">
                <div class="title">JOIN US</div>

                <a href="mailto:careers@huehexdesign.com">careers@huehexdesign.com</a>
                +91-8792741516
              </div>
              <div class="contact-info">
                <div class="title">LET'S MEET</div>4th Cross Rd, South Avenue, Gottigere, Bengaluru, Karnataka 560083, India
              </div>
              <!-- <div class="googlemap">Google map arrow for google map</div> -->
            </div>
          </div>
        </div>
      </aside>
    </div>
  </section>
</template>

<script>
import contactform from "@/components/contactform.vue";
export default {
  name: "contact",
  props: {
    title: String
  },
  components: { contactform }
};
</script>

<style scoped lang="scss">
.contact-info{
  line-height: 2.15;
  text-align: left;
  margin-top: 50px;
  .title{
    font-size: 20px;
    font-weight: 500;
    line-height: 2.15;
  }
  a{
    display: block;
    color:$white;
    text-decoration: none;
  }
  
}
.googlemap{
  margin-top: 50px;
    text-align: left;
  }
</style>
